export default __webpack_public_path__ + "./images/star.b4450bc2.svg";